import { render } from "./DashboardRecentDatasets.vue?vue&type=template&id=1f8e23aa"
import script from "./DashboardRecentDatasets.vue?vue&type=script&lang=js"
export * from "./DashboardRecentDatasets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__